import {AExt} from "@/classes/ext/a-ext";
import {IProdStartInput, prodStartModule} from "@/store/prod/start";

export class ExtStart extends AExt {

    // Computed //////////////////////////////////
    public get progress(): IProdStartInput {
        return prodStartModule.input;
    }

    // Methods //////////////////////////////////

    public async loadStartProgress() {
        await prodStartModule.load();
    }

    public async loadWizardProgress() {
        await prodStartModule.load();
    }

    public async update(input: any, save: boolean = true) {
        await prodStartModule.updateInput({
            ...this.progress,
            ...input,
        });
        if (save) {
            await prodStartModule.save();
        }
    }

    public async clear() {
        await prodStartModule.resetInput();
    }
}
